import { connect } from 'react-redux';
import { setMicSelected } from '../../actions';
import MicSelector from './MicSelector';

const mapStateToProps = ({
  scribeConversation: { micIdSelected, availableMics },
}) => ({
  micIdSelected,
  availableMics,
});

export default connect(
  mapStateToProps,
  {
    setMicSelected,
  }
)(MicSelector);
